import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cell-controls" },
    [
      _vm.showName
        ? [
            _c(
              "div",
              { staticClass: "row-name", attrs: { title: _vm.rowName } },
              [_vm._v(_vm._s(_vm.rowName))]
            ),
          ]
        : [
            _c(VSelect, {
              staticClass: "store-group-dropdown",
              class: { "dropdown-expanded": _vm.isExpanded },
              attrs: {
                value: _vm.selectedOption,
                items: _vm.dropdownOptions,
                "item-text": "label",
                "item-value": "value",
                dense: "",
                "hide-details": "",
                disabled: !_vm.hasDropdownOptions,
                loading: _vm.splitLoading && _vm.isExpanded,
                "append-icon": _vm.dropdownAppendIcon,
              },
              on: { change: _vm.onDropdownChange },
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }